import React from 'react';
import { connect } from 'react-redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { isNullOrUndefined, getLanguage } from '../../store/storeFunctions';

import RepiCz from '../../img/repi/RepiCz';
import RepiEn from '../../img/repi/RepiEn';
import RepiSk from '../../img/repi/RepiSk';

class RepiFooter extends React.Component {
    render() {
        const agentLanguage = !isNullOrUndefined(this.props.user.authentication.profile)
            ? this.props.user.authentication.profile.agentLanguage : getLanguage();

        let label = "Repi.Footer.Cz";
        let Icon = RepiEn;

        if  (agentLanguage === "sk-SK") {
            label = "Repi.Footer.Sk";
            Icon = RepiSk;
        } else if (agentLanguage === "cs-CZ")
            Icon = RepiCz;

        return (
            <div className="disclaimer-wrapper">
                <div className="disclaimer-gray repi-footer repi-logo-colorized">
                    <Icon />
                    <Translate id={label} options={{ renderInnerHtml: true }} />
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({ user: state.userContext, ...state.repi }),
    null
)(withLocalize(RepiFooter));